import { render, staticRenderFns } from "./_base-udnreport.vue?vue&type=template&id=5d73f83f&scoped=true"
import script from "./_base-udnreport.vue?vue&type=script&lang=js"
export * from "./_base-udnreport.vue?vue&type=script&lang=js"
import style0 from "./_base-udnreport.vue?vue&type=style&index=0&id=5d73f83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73f83f",
  null
  
)

export default component.exports